import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Overlay as OverlayRoot } from './style';
import { OVERLAY_CLASS_PREFIX } from './constants';
import { useTheme } from '../../styling';
export var Overlay = function Overlay(_ref) {
  var disableEffects = _ref.disableEffects,
      display = _ref.display,
      effectToggle = _ref.effectToggle,
      onClick = _ref.onClick,
      restProps = _objectWithoutProperties(_ref, ["disableEffects", "display", "effectToggle", "onClick"]);

  var theme = useTheme();
  return React.createElement(OverlayRoot, Object.assign({}, restProps, {
    className: "Overlay",
    disableEffects: disableEffects,
    display: display,
    effectToggle: effectToggle,
    onClick: onClick,
    theme: theme
  }));
};
Overlay.displayName = OVERLAY_CLASS_PREFIX;
Overlay.defaultProps = {
  tabIndex: 0
};